/* ================= Render loop ================= */
var repodLastRendererPixelRatio = renderer && typeof renderer.getPixelRatio === 'function'
  ? renderer.getPixelRatio()
  : Math.min(window.devicePixelRatio || 1, 2);
var repodPresentationQuality = !!window.repodPresentationQuality;

function repodMainIsCoarsePointerDevice(){
  return (window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches) || window.innerWidth < 768;
}

function updateRepodRendererQuality(now){
  var pixelRatioCap = repodPresentationQuality
    ? 2
    : (repodMainIsCoarsePointerDevice() ? 1.25 : 1.6);
  var targetPixelRatio = Math.min(window.devicePixelRatio || 1, pixelRatioCap);

  if (Math.abs(targetPixelRatio - repodLastRendererPixelRatio) < 0.01) return;
  repodLastRendererPixelRatio = targetPixelRatio;
  renderer.setPixelRatio(targetPixelRatio);

  var modelContainer = renderer.domElement && renderer.domElement.parentElement;
  if (modelContainer) {
    renderer.setSize(modelContainer.clientWidth, modelContainer.clientHeight);
  }
}

function setRepodPresentationQuality(active){
  repodPresentationQuality = !!active;
  window.repodPresentationQuality = repodPresentationQuality;
  // Apply the new backing-buffer density immediately when the shared model is
  // moved, instead of showing one visibly soft frame at the old pixel ratio.
  updateRepodRendererQuality(performance.now());
  if (typeof drawScreen === 'function') drawScreen();
}

function repodUsesMobileViewControls(){
  return (window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches) || window.innerWidth < 768;
}

function repodUsesExperienceScenes(){
  return !!(
    renderer &&
    renderer.domElement &&
    renderer.domElement.closest('[data-repod-experience]')
  );
}

var repodLastExperienceScenesActive = null;

function animate(){
  requestAnimationFrame(animate);
  var repodScreenFramePending = window.repodScreenFramePending === true;
  if (window.repodInViewport === false && !repodScreenFramePending) {
    return;
  }
  var now=performance.now();
  updateRepodRendererQuality(now);
  var dt=Math.min((now-lastFrameT)/1000,0.05); lastFrameT=now;
  var introActive=typeof productIntro!=='undefined'&&productIntro.active;
  if(introActive){
    productIntro.update(now,dt);
    introActive=productIntro.active;
  }
  var experienceScenesActive=repodUsesExperienceScenes();
  var experienceScenesReady=experienceScenesActive &&
    typeof APP!=='undefined' &&
    typeof gameApp!=='undefined';
  var idleNeed = experienceScenesReady && APP===gameApp ? 2200 : 5200;
  var spinOK = !experienceScenesReady || APP!==gameApp || gameAllowsAutoSpin();
  if(auto && !introActive && now-lastInteract>idleNeed && spinOK) tTheta+=0.004;
  var viewEase=repodUsesMobileViewControls()?0.145:0.08;
  var viewStep=1-Math.pow(1-viewEase,dt*60);
  theta+=(tTheta-theta)*viewStep;
  phi  +=(tPhi  -phi  )*viewStep;
  radius+=(tRadius-radius)*viewStep;
  camera.position.set(
    radius*Math.sin(phi)*Math.sin(theta),
    radius*Math.cos(phi),
    radius*Math.sin(phi)*Math.cos(theta)
  );
  camera.lookAt(0,typeof productIntro!=='undefined'?productIntro.lookY:-0.15,0);
  device.position.y=typeof productIntro!=='undefined'?productIntro.yOffset:0;
  device.scale.setScalar(typeof productIntro!=='undefined'?productIntro.scale:0.82);
  device.rotation.x=typeof productIntro!=='undefined'?productIntro.rotX:0;
  device.rotation.y=typeof productIntro!=='undefined'?productIntro.rotY:0;
  /* The Hero/Banner keeps its post-intro tilt, while the shared model is
     presented upright in the homepage experience section. */
  device.rotation.z=experienceScenesActive
    ? 0
    : (typeof productIntro!=='undefined'?productIntro.rotZ:0);

  /* App and game state only runs while the model is mounted in the experience section. */
  if(experienceScenesReady && APP.update) APP.update(dt);
  if(experienceScenesReady && typeof musicApp !== 'undefined' && APP===musicApp){
    musicTick();
    musicGainTick(dt);
  }
  donutPivot.rotation.z=-wheelAngle+(typeof productIntro!=='undefined'?productIntro.wheelSpin:0);                 // wheel pose follows accumulated circular input; demo mode follows AI
  wheelGlow+=(clamp((isDraggingWheel?1:0)+(typeof productIntro!=='undefined'?productIntro.wheelGlow:0),0,1)-wheelGlow)*0.12;
  shadowRing.material.opacity=0.38+0.22*wheelGlow;   // wheel touch makes the body shadow more visible
  // The Banner uses a static screen image. Avoid repainting its large 2D
  // texture and rebuilding mipmaps on every animation frame; interactive
  // scenes still redraw continuously after the model moves below the fold.
  if(experienceScenesActive || experienceScenesActive !== repodLastExperienceScenesActive){
    drawScreen();
  }
  repodLastExperienceScenesActive=experienceScenesActive;

  chargeT+=((charging?1:0)-chargeT)*0.06;
  charger.visible=chargeT>0.01;
  charger.position.z=THREE.MathUtils.lerp(-3.0,-0.58,chargeT);
  glowMat.opacity=chargeT*(0.45+0.25*Math.sin(now*0.005));
  gLight.intensity=chargeT*(0.5+0.3*Math.sin(now*0.005));
  
  latchRot+=((latchOpen?0:Math.PI)-latchRot)*0.1;
  latchRotor.rotation.z=latchRot;
  renderer.render(scene,camera);
  if(repodScreenFramePending) window.repodScreenFramePending=false;
  if(!window.repodModelLoaded) {
    window.repodModelLoaded = true;
    var container = document.querySelector('.hero__model-container');
    if(container) {
      var productEl = container.closest('.hero__product');
      if(productEl) {
        productEl.classList.remove('model-load-failed');
        productEl.classList.add('model-is-ready');
      }
    }
  }
}
animate();

// Use ResizeObserver for local container resizing
var container = document.querySelector('.hero__model-container');
if (container && window.ResizeObserver) {
  var ro = new ResizeObserver(function(entries) {
    for (var entry of entries) {
      var w = entry.contentRect.width;
      var h = entry.contentRect.height;
      if (w && h) {
        camera.aspect = w / h;
        camera.updateProjectionMatrix();
        renderer.setSize(w, h);
        if (typeof updateViewRadiusBounds === 'function') updateViewRadiusBounds();
      }
    }
  });
  ro.observe(container);
} else if (container) {
  window.addEventListener('resize',function(){
    var w = container.clientWidth;
    var h = container.clientHeight;
    camera.aspect=w/h;
    camera.updateProjectionMatrix();
    renderer.setSize(w,h);
    if (typeof updateViewRadiusBounds === 'function') updateViewRadiusBounds();
  });
}

function resizeRepodRuntime(){
  var modelContainer = renderer.domElement && renderer.domElement.parentElement;
  if(!modelContainer) return;
  var w = modelContainer.clientWidth;
  var h = modelContainer.clientHeight;
  if(!w || !h) return;
  camera.aspect = w / h;
  camera.updateProjectionMatrix();
  renderer.setSize(w,h);
  if(typeof updateViewRadiusBounds === 'function') updateViewRadiusBounds();
}

var repodPresentationLighting = (function(){
  var normal = {
    exposure: renderer.toneMappingExposure,
    key: repodKeyLight.intensity,
    fill: repodFillLight.intensity,
    rim: repodRimLight.intensity
  };
  var frontLight = new THREE.DirectionalLight(0xffffff,0);
  var softFill = new THREE.HemisphereLight(0xffffff,0xb8bec8,0);
  frontLight.position.set(0,3.5,8.5);
  scene.add(frontLight);
  scene.add(softFill);

  function setPresentationLighting(active){
    if(active){
      renderer.toneMappingExposure=1.18;
      repodKeyLight.intensity=1.42;
      repodFillLight.intensity=0.62;
      repodRimLight.intensity=0.92;
      frontLight.intensity=1.12;
      softFill.intensity=0.46;
    }else{
      renderer.toneMappingExposure=normal.exposure;
      repodKeyLight.intensity=normal.key;
      repodFillLight.intensity=normal.fill;
      repodRimLight.intensity=normal.rim;
      frontLight.intensity=0;
      softFill.intensity=0;
    }
  }

  return {
    set: setPresentationLighting
  };
})();

window.renderer = renderer;
window.camera = camera;
window.repodHeroRuntime = {
  renderer: renderer,
  scene: scene,
  camera: camera,
  device: device,
  modelElement: renderer.domElement.closest('.hero__product'),
  drawScreen: drawScreen,
  resize: resizeRepodRuntime,
  lighting: repodPresentationLighting,
  quality: {
    set: setRepodPresentationQuality,
    get: function(){ return repodPresentationQuality; }
  },
  skipIntro: function(){
    if(typeof productIntro !== 'undefined' && productIntro && typeof productIntro.skip === 'function'){
      productIntro.skip();
    }
  },
  playIntro: function(){
    if(typeof productIntro !== 'undefined' && productIntro && typeof productIntro.play === 'function'){
      return productIntro.play();
    }
    return false;
  },
  scenes: window.repodSceneController,
  model: window.repodModelController
};
document.dispatchEvent(new CustomEvent('repod:runtime-ready', {
  detail: window.repodHeroRuntime
}));
